/**
 * Defines an event Feature, such as "Event Management", "Streaming", or "Registration".
 * This helps us know why they are creating an event and what systems they plan to use
 */
export class Feature {
    public static EVENT_MGMNT_ID: string = '07fbc8fd-ca57-45cf-b95d-3a9a4b486650';
    public static NON_ARENA_EVENT_ID: string = '522c8e4f-a61d-e97a-582f-03f1f85d2b58';
    public static STREAMING_ID: string = '22b7ab42-b596-4f1a-a1f9-76af9b88a3ec';
    public static REGISTRATION_ID: string = '914b34d9-b108-4b5b-adbb-140b1c9e3d1b';

    public id: string;
    public name: string;

    constructor(id: string = null) {
        this.id = id;
    }

    public clone(): Feature {
        const clone: Feature = new Feature();
        clone.id = this.id;
        clone.name = this.name;
        return clone;
    }

    /**
     * Serialize from a json api fomat
     */
    public serialize(): string {
        return JSON.stringify(this);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): Feature {
        const attrs: Object = json['attributes'];

        this.id = json['id'];
        this.name = attrs['name'];
        return this;
    }
}
